const {
  hasContentValue
} = require('@truqc/content-path');
const {
  isPlainObject,
  isEqual
} = require('lodash');
const {
  maxSignificantDigits
} = require('./constants');
const isEqualEnough = (a, b) => {
  const isDecimal = n => !Number.isNaN(parseFloat(n)) && Number.isFinite(n) && !Number.isInteger(n);
  if (a === b) {
    return true;
  }
  if (isDecimal(a) && isDecimal(b) && Number.parseFloat(a).toPrecision(maxSignificantDigits) === Number.parseFloat(b).toPrecision(maxSignificantDigits)) {
    return true;
  }
  return false;
};
const generateMergePatch = (before, after) => {
  if (before === null || after === null || typeof before !== 'object' || typeof after !== 'object') {
    return after;
  }
  const patch = {};
  const beforeKeys = Object.keys(before);
  const afterKeys = Object.keys(after);
  let key;
  let i;

  // new elements
  const newKeys = {};
  for (i = 0; i < afterKeys.length; i += 1) {
    key = afterKeys[i];
    if (beforeKeys.indexOf(key) === -1) {
      newKeys[key] = true;
      patch[key] = after[key];
    }
  }

  // removed & modified elements
  for (i = 0; i < beforeKeys.length; i += 1) {
    key = beforeKeys[i];
    if (afterKeys.indexOf(key) === -1) {
      patch[key] = null;
    } else if (before[key] !== null && typeof before[key] === 'object') {
      // if atomic, treat everything under here as one value
      // eslint-disable-next-line no-underscore-dangle
      if (before[key]._atomic === true) {
        // if they are not equal, copy everything from after
        // to the patch.
        if (!isEqual(before[key], after[key])) {
          patch[key] = after[key];
          // eslint-disable-next-line no-underscore-dangle
          patch[key]._atomic = true;
        }
        // else do nothing - they are equal, so patch igores this key
      } else {
        const subPatch = generateMergePatch(before[key], after[key]);
        if (subPatch !== undefined) {
          patch[key] = subPatch;
        }
      }
    } else if (!isEqualEnough(before[key], after[key])) {
      patch[key] = after[key];
    }
  }
  return Object.keys(patch).length > 0 ? patch : undefined;
};
const applyMergePatchMutate = (target, patch) => {
  if (!isPlainObject(patch)) {
    return patch;
  }
  Object.keys(patch).forEach(key => {
    if (patch[key] === null) {
      if (target[key] !== undefined) {
        // eslint-disable-next-line no-param-reassign
        delete target[key];
      }
    } else if (isPlainObject(patch[key])
    // eslint-disable-next-line no-underscore-dangle
    && patch[key]._atomic === true) {
      // _atomic indicates this should be treated
      // as an atomic value - so
      // overwrite everything from here down with
      // what is in the patch - do not merge the
      // objects.
      if (target[key] !== undefined) {
        // eslint-disable-next-line no-param-reassign
        delete target[key];
      }
      // eslint-disable-next-line no-param-reassign
      target[key] = patch[key];
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      delete target[key]._atomic;
    } else if (hasContentValue(patch[key])) {
      // eslint-disable-next-line no-param-reassign
      target[key] = applyMergePatchMutate(target[key] || {}, patch[key]);
    }
    // remove empty objects from tree
    if (isPlainObject(target[key]) && Object.keys(target[key]).length === 0) {
      // eslint-disable-next-line no-param-reassign
      delete target[key];
    }
  });
  return target;
};
const applyMergePatch = (targetIn, patch) => {
  const target = targetIn === undefined ? {} : JSON.parse(JSON.stringify(targetIn));
  return applyMergePatchMutate(target, patch);
};
module.exports = {
  generateMergePatch,
  applyMergePatch
};